module.exports = __webpack_public_path__ + "img/selected4-min.5d803155.png";